import { SubscriptionBillingPeriod } from 'types/domain';

interface OverageMessageProps {
    billingPeriod: SubscriptionBillingPeriod;
}

const OverageMessage = ({ billingPeriod }: OverageMessageProps) => {
    return (
        <p className="text-xs text-gray-600">
            *Overage fees are calculated per 100 extra contacts. Overages will be prorated for the
            remainder of your subscription period and billed{' '}
            {billingPeriod === 'year' ? 'immediately' : 'at your next invoice'}.
        </p>
    );
};
export { OverageMessage };
